




































import Vue from "vue";
//import EditableCell from "../components/EditableCell.vue";

const columns = [
  {
    title: "Uhrzeit",
    dataIndex: "uhrzeit",
    key: "uhrzeit",
  },
  {
    title: "Montag",
    dataIndex: "montag",
    key: "montag",
    scopedSlots: { customRender: "1" }
  },
  {
    title: "Dienstag",
    dataIndex: "dienstag",
    key: "dienstag",
    scopedSlots: { customRender: "2" }
  },
  {
    title: "Mittwoch",
    dataIndex: "mittwoch",
    key: "mittwoch",
    scopedSlots: { customRender: "3" }
  },
  {
    title: "Donnerstag",
    dataIndex: "donnerstag",
    key: "donnerstag",
    scopedSlots: { customRender: "4" }
  },
  {
    title: "Freitag",
    dataIndex: "freitag",
    key: "freitag",
    scopedSlots: { customRender: "5" }
  },
  {
    title: "Samstag",
    dataIndex: "samstag",
    key: "samstag",
    scopedSlots: { customRender: "6" }
  },
  {
    title: "Sonntag",
    dataIndex: "sonntag",
    key: "sonntag",
    scopedSlots: { customRender: "7" }
  }
];

interface DataRow {
  [key: string]: string | number | undefined;
  key: string;
  uhrzeit: string;
  montag?: number;
}
const data: Array<DataRow> = [];

for (let i = 6; i < 24; i++) {
  data.push({
    uhrzeit: `${i}-${i + 1} Uhr`,
    key: i.toString(),
  });
}

export default Vue.extend({
  components: {
   // EditableCell
  },
  name: "SalesPlanning",
  data() {
    return {
      data,
      columns,
      weekdays: ["1", "2", "3", "4", "5", "6", "7"]
    };
  },
  
  methods: {
    onCellChange(hourKey: string, weekdayKey: string, event: any) {
      const sales = parseFloat(event.currentTarget.value);
      if (!sales || isNaN(sales)) {
        return;
      }
      const data = [...this.data];
      const target = data.find(item => item.key === hourKey);
      if (target) {
        this.$store.commit("setSalesForWeekdayAndHours",{
          isoWeekday: weekdayKey,
          hour: hourKey,
          salesInEuro: sales,
        });
      }
    }
  }
});
